"use client"
import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import './subscriptionPlans.css';
import { deleteSubscription } from './subscriptionPlans.service';
import { Icon } from "@iconify/react";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    maxHeight: '100vh',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 0,
    overflowY: 'auto',
    borderRadius: '8px',
    p: '20px',
};

export default function DeleteModal(props) {

    const { onClose, getSubscriptionData, selectedId, setResponseMsg, setAlert, setOpenAlert, setLoading, ALERT_DURATION, alertClose } = props;

    const onSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        const res = await deleteSubscription(selectedId);

        if (res?.statusCode === 200) {
            setResponseMsg(res.message);
            setLoading(false);
            setAlert('true');
            setOpenAlert(true);
            setTimeout(() => {
                alertClose();
                getSubscriptionData();
                onClose();
            }, ALERT_DURATION);
        } else if (res.statusCode === 400 || res.statusCode === 404 || res.statusCode === 500 || res.statusCode === 429) {
            setResponseMsg(res.message);
            setLoading(false);
            setAlert('false');
            setOpenAlert(true);
            setTimeout(alertClose, ALERT_DURATION);
        } else {
            setAlert('false');
            setOpenAlert(true);
            setLoading(false);
            setTimeout(alertClose, ALERT_DURATION);
        }
    };

    return (
        <Box sx={style}>

            <Grid container alignItems={'center'} pb={2}>
                <Grid size={12} textAlign={'end'}>
                    <CancelIcon onClick={onClose} sx={{ color: '#C40000', cursor: 'pointer' }} />
                </Grid>
            </Grid>
            <form onSubmit={onSubmit}>
                <Grid container alignItems={'center'} justifyContent={'center'} py={2}>
                    <Grid size={12} textAlign={'center'}>
                        <Icon icon="proicons:alert-triangle" width="70" height="70" style={{ color: "#C40000" }} />
                        <Typography sx={{ color: '#C40000', fontWeight: 900, fontSize: 24, padding: 1 }}> Warning !</Typography>
                        <Typography>Do you want to continue ? </Typography>
                        <Typography>This action cannot be undone.</Typography>
                    </Grid>
                </Grid>
                <Grid container justifyContent={'center'} py={2}>
                    <Button variant="contained" type="submit" className='createBtn'>Yes</Button>&nbsp;&nbsp;&nbsp;
                    <Button variant="contained" className='cancelBtn' onClick={onClose}>No</Button>
                </Grid>
            </form>

        </Box>
    )
}
